/**
 * Basic wine type of champagne
 */
export type ChampagneBasicWineType = 'VARIETAL_WINE' | 'COUPAGE_CUVEE';

export const ChampagneBasicWineType = {
  VarietalWine: 'VARIETAL_WINE' as ChampagneBasicWineType,
  CoupageCuvee: 'COUPAGE_CUVEE' as ChampagneBasicWineType,
};
